<div class="flex flex-column gap-2">
  <div
    style="display: flex; align-items: center; justify-content: space-between"
  >
    <h1 class="m-0 text-900 font-semibold text-xl line-height-3">
      Inicia sesión para continuar
    </h1>
    <div class="p-dialog-header-icons">
      <button
        type="button"
        role="button"
        class="p-dialog-header-icon p-dialog-header-maximize p-link"
        aria-label="Close"
        (click)="ref.close()"
      >
        <i class="fa-sharp-duotone fa-solid fa-times text-xl"> </i>
      </button>
    </div>
  </div>
  <span class="text-600 text-base"
    >Hemos detectado que el email ingresado ya se encuentra registrado, por
    favor inicie sesión para continuar.</span
  >
</div>
